/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../../../../core/components/base.component';

@Component({
    selector: 'app-cm-header-notifications',
    templateUrl: './cm-notifications.component.html',
    styleUrls: ['./cm-notifications.component.scss'],
    encapsulation: ViewEncapsulation.None // Used to format ng-content as blocks.
})

export class CmNotificationsComponent extends BaseComponent {
    /**
     * Total number of alerts/notifications
     */
    public totalNotifications: number = 99;

    constructor(
        // public navigationService: NavigationService,
        public route: ActivatedRoute,
        // private notifyService: NotifyService,
        private router: Router,
    ) {
        super();

        // Get initial notification length before subscribing.
        // this.totalNotifications = this.notifyService.getNotifications().length;

        // Subscribe to changes to the system notifications
        // this.notifyService.emitter.pipe(takeUntil(this.destroyed$))
        //     .subscribe((data) => {
        //             this.totalNotifications = this.notifyService.getNotifications().length;
        //         }
        //     );
    }

    public internalLink(url) {
        this.router.navigate([url], { relativeTo: this.route.firstChild }).catch().then(() => {
        });
    }
}
